// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"action_tooltip__mvKUh","action":"action_action__o1yyL"};